<template>
  <section style="height: 95vh" class="d-flex flex-column justify-center">
    <v-row align-content="center" justify="center" class="pt-10">
      <v-col cols="12" class="d-flex justify-center">
        <v-img :height="60" :src="logo" />
      </v-col>
      <v-col cols="12">
        <v-form
          ref="form"
          v-model:model-value="form.valid"
          :disabled="loader.loading"
          style="max-width: 300px; margin: 0 auto"
          @submit.prevent="auth"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="user.username"
                color="primary"
                bg-color="white"
                label="E-mail"
                type="email"
                :rules="[required]"
                variant="outlined"
                append-inner-icon="fa-regular fa-at"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="user.password"
                color="primary"
                bg-color="white"
                label="Senha"
                :rules="[required]"
                :append-inner-icon="showPass ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'
                "
                :type="showPass ? 'text' : 'password'"
                variant="outlined"
                hide-details
                @click:append-inner="showPass = !showPass"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                block
                color="secondary"
                density="default"
                size="x-large"
                type="submit"
                :loading="loader.loading"
              >
                Acessar
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-divider class="mt-8 mx-3" />
          </v-row>

          <v-row justify="center">
            <a style="outline: none" class="py-4">Esqueceu sua senha?</a>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import logo from '../../assets/images/logo_black.png'

import { computed, ref } from 'vue'
import { useAdminStore } from '../../stores/admin'

import AuthService from '@/services/AuthService'
import ProducerService from '@/services/ProducerService'
import AdminService from '@/services/AdminService'
import { useProducerStore } from '../../stores/producer'
import type Producer from '@/types/Producer'
import { usePermissionStore } from '@/stores/permission'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRouter } from 'vue-router'
import { required } from '@/helpers/rules/required'

const loader = useLoader()
const snackbar = useSnackBar()
const router = useRouter()

const form = ref({
  rules: {
    required: (v: string) => !!v || 'Campo obrigatório',
  },
  valid: null,
})

const showPass = ref(false)

const user = ref({
  username: '',
  password: '',
})

const token = computed({
  get() {
    return useAdminStore().token
  },
  set(value: string) {
    useAdminStore().token = value
  },
})

async function auth() {
  if (!form.value.valid) {
    snackbar.show(
      'Verifique se os campos e cargos foram preenchidos corretamente',
      'warning',
    )
    return
  }

  try {
    loader.increment()

    token.value = await new AuthService().auth(user.value.username, user.value.password)

    const [admin, abilities, producers] = await Promise.all([
      new AdminService().fetch(),
      new AdminService().abilities(),
      new ProducerService().index(1, '', 1000),
    ])

    useAdminStore().setAdmin(admin)
    usePermissionStore().update(abilities)
    useProducerStore().producers = producers.data.data.sort(
      (a: Producer, b: Producer) => a.data.trade_name.localeCompare(b.data.trade_name),
    )

    if (producers.data.data.length === 1) {
      useProducerStore().producer = producers.data.data[0]
      router.push('/events')
    } else {
      router.push('/producers')
    }
  } finally {
    loader.decrement()
  }
}
</script>
